'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Container, ListGroup } from 'reactstrap';
import { useRouter, useParams } from 'next/navigation';
import queryString from 'query-string';
import ContentSection from 'shared/components/ContentSection';
import ContentRow from 'shared/components/ContentRow';
import JobTeaser from 'shared/components/JobTeaser';
import Pager from 'shared/components/Pager';
import AppLayout from '../../../../components/AppLayout';
import { PageHeaderType } from 'shared/components/pageHeader/Index';
import { getI18nUtils } from 'shared/i18n/i18n-utils';

export default function JobDomainPage({
  id,
  pageId,
  availableLocales,
  intro,
  dictionary,
  body,
  jobData,
  page,
  title,
  headerImg,
}) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();
  const { locale } = useParams();
  let firstJob;
  let lastJob;
  if (jobData) {
    firstJob = page * 10 - 9;
    lastJob = page * 10 > jobData.count ? jobData.count : page * 10;
  }
  let pageHeader: PageHeaderType | null = null;
  let noSpacer = false;
  if (headerImg) {
    pageHeader = {
      srcSet: headerImg,
      type: 'fullWidthImg',
      bgImageAlt: `${headerImg.description}`,
    };
    noSpacer = true;
  }
  function navigate(newPage) {
    const query = queryString.stringify({ page: newPage });
    push(`/${locale}/jobs/${id}/?${query}`);
  }
  return (
    <AppLayout
      dictionary={dictionary}
      pageHeader={pageHeader !== null ? pageHeader : undefined}
      className="jobsPage"
      noSpacer={noSpacer}
      availableLocales={availableLocales}
    >
      <Container style={{ maxWidth: 960 }} tag="section" className="my-4">
        <h1 className="pt-2 h2">{title}</h1>
        <div className="my-4 py-2 lead" dangerouslySetInnerHTML={{ __html: intro }} />
        <ContentRow>
          {body &&
            body.map((section, index) => (
              <ContentSection
                dictionary={dictionary}
                key={`section-${index}`}
                section={section}
                source="jobPage"
                id={pageId}
                className="py-2"
              />
            ))}
        </ContentRow>
        {jobData && jobData.matches && (
          <section className="mt-2 py-2">
            <div
              id="resultCount"
              className="d-flex justify-content-between align-items-md-center flex-column flex-md-row ms-2 pb-3"
            >
              <h2 className="mb-0">
                {firstJob} - {lastJob} {formatMessage({ id: 'of' })} <span id="count">{jobData.count}</span>{' '}
                {formatMessage({ id: 'jobs-found' })}
              </h2>
            </div>
            <ListGroup>
              {jobData.matches.map((job) => (
                <JobTeaser dictionary={dictionary} job={job} key={job.id} titleTag="h3" />
              ))}
            </ListGroup>
            <Pager
              className="mt-3"
              currentPage={page}
              totalPages={Math.ceil(jobData.count / jobData.maxHits)}
              changePage={(newPage) => navigate(newPage)}
            />
          </section>
        )}
      </Container>
    </AppLayout>
  );
}
